<template>
    <div class="form-field form-color" :rel="name" v-bind:class="{'form-required': requiredForm}">
        <div class="form-label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
                <label v-for="item in options">
                    <input type="checkbox" v-model="internalValue" :value="item"/>
                    <span><span class="color"><i v-bind:style="{background:item.color}"></i></span> {{ item.name }}</span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormField',
        props: ['value','label','name','placeholder','multiple', 'default','options','callback','required'],
        data: function () {
            return {
                internalValue: ''
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.isMultiple = this.multiple == 'true' ? true : false;
            this.onChange = this.callback ? true : false;
        },
        methods: {
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'default'(newVal, oldVal) {
                if( newVal && this.options){
                    for (let item of this.options) {
                        if( item.id && item.id.toString().toLowerCase() == newVal.toString().toLowerCase() ){
                            this.internalValue = item;
                        }
                    }
                }
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
                if( this.onChange ){
                    this.callback(this.internalValue)
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Color.vue